import { generateClient } from 'aws-amplify/api';
const API = generateClient();
export default API;
